(function(){
    document.querySelectorAll('.btn-expand-header').forEach(function(element) {
        element.addEventListener('click', function(event) {
            event.preventDefault();

            var header_wrapper = this.closest('.header-wrapper');
            header_wrapper.classList.toggle("active");

            return false;
        });
    });

    document.querySelectorAll('.hmm-toggle').forEach(function(element) {
        element.addEventListener('click', function(event) {
            event.preventDefault();

            document.body.classList.toggle("header-mobile-menu-open");
            if (document.body.classList.contains('header-mobile-menu-open')) {
                document.body.style.paddingRight = getScrollbarWidth()+'px';
            } else {
                document.body.style.paddingRight = 0;
            }

            return false;
        });
    });
})();